/**
 * These events are part of a contract with in app messages and lessons
 * please be cautious while changing these event.
 */
export const SHOW_USAGE = 'showUsage';
export const OPEN_INVITE_MODAL = 'openInviteModal';
export const OPEN_UPGRADE_TEAM_MODAL = 'openUpgradeTeamModal';
export const OPEN_LESSON_PLAN = 'openLessonPlanModal';
export const XPATH_REGISTERED = 'xPathRegistered';
export const XPATH_UNREGISTERED = 'xPathUnregistered';
export const OPEN_SIGNIN_WINDOW = 'openSignInWindow';
export const ONBOARDING_TARGET_CLICKED = 'onboardingTargetClicked';
export const TEAM_DETAILS_UPDATED = 'teamDetailsUpdated';
export const ENTITY_LOADED_IN_TAB = 'entityLoadedInTab';
export const LOGOUT_EVENT = 'logout';
export const SAMPLE_API_IMPORT = 'sampleAPIImport';
export const CLOSE_API_VERSIONS = 'closeAPIVersions';
export const SWITCH_TO_API_TEST_TAB = 'switchToAPITestTab';
export const SWITCH_TO_API_MONITORING_TAB = 'switchToAPIMonitoringTab';
export const OPEN_PRIVATE_NETWORK_ADD_ENTITY_MODAL = 'openAddEntityModal';
export const MOCK_CREATED = 'mockCreated';
export const MOCK_CREATION_TAB_LOADED = 'mockCreationTabLoaded';
export const ENVIRONMENT_CREATED = 'environmentCreated';
export const OPEN_PRIVATE_NETWORK_BULK_ADD_ENTITY_MODAL = 'openBulkAddEntityModal';
